import cn from 'classnames';

import * as styles from './BigScreenLandingPage.module.scss';

export const Box = ({
  children,
  withBackground = false,
}: {
  children: React.ReactNode;
  withBackground?: boolean;
}) => (
  <div className={cn(styles.box, { [styles.boxBackground]: withBackground })}>
    {children}
  </div>
);
